import { useQuery } from "react-query";
import API from "../shared-utils/api";
import { useCustomer } from "../contexts/CustomerProvider";
import { API_ENDPOINTS } from "../shared-constants";
export const getUserCoupons = async (userId, pubId) => {
    if (!userId)
        return null;
    const { data } = await API.get(API_ENDPOINTS.WALLET.USER_COUPONS(userId, pubId));
    return data;
};
export const useUserCoupons = (pubId) => {
    var _a;
    const { customerData } = useCustomer();
    const userId = (_a = customerData === null || customerData === void 0 ? void 0 : customerData.id) !== null && _a !== void 0 ? _a : null;
    return useQuery(["user_coupons", userId, pubId], () => getUserCoupons(userId, pubId), {
        enabled: !!userId,
    });
};
